<template>
  <div class="pages">
    <div class="top facab">
      <div class="t-l">{{ $t('main.AddressInformation') }}</div>
      <div class="t-r fac">
        <div class="t-r-l fac">
          <div style="padding: 0 1.875rem;color: #fff;font-weight: bold">
            {{ $t('main.AddressInformation') }}
          </div>
        </div>
        <img src="/static/product/icn_right.png" class="tImg" />
        <div class="t-r-e">{{ $t('main.ShippingInformation') }}</div>
        <img src="/static/product/icn_right.png" class="tImg" />
        <div class="t-r-e">{{ $t('main.ReviewPayment') }}</div>
      </div>
    </div>
    <div class="content">
      <el-row>
        <el-col :span="16" style="padding-right:1.5rem;">
          <div class="c-th facab">
            <div class="cPointer color-e31409">{{ $t("main.ConsigneeInformation") }}</div>
          </div>
          <div class="addr-serach">
            <el-input
                :placeholder="$t('main.searchAddress')"
                v-model="address_search"
                class="input-with-select"
                @keyup.enter.native="addressSearch()"
            >
              <el-button slot="append" icon="el-icon-search" @click="addressSearch()"></el-button>
            </el-input>
          </div>
          <div class="addr-list">
            <el-radio-group
                v-model="addressIdChooise"
                v-if="addressList.length"
            >
              <el-radio
                  v-for="(item, key) in addressList"
                  :key="key + 0.001"
                  :label="item.id"
              >
                <span style="font-weight: bold;color: rgb(51, 51, 51);padding-right: 1.5rem;" v-if="item.status == 1"> {{ $t('main.defaultAddress') }}</span>
                <span style="font-weight: bold;color: rgb(51, 51, 51);"> {{ item.receive_user }}</span>
                <span style="color: rgb(153, 153, 153);"> {{ item.receive_address }}</span>
                <span style="color: #635796;padding-left: 1.5rem;" @click="editAddressDialog(item)"> {{ $t('main.edit') }}</span>
              </el-radio>
            </el-radio-group>
            <el-pagination
                v-if="addressList.length"
                layout="prev, pager, next"
                hide-on-single-page
                :total="address.total"
                :current-page="address.page"
                :page-size="address.limit"
                @current-change="handleCurrentAddressChange"
            >
            </el-pagination>
            <div class="add-address color-635796" @click="addressDialogVisible = true;addressOperateFlag=true">
              {{ $t("main.add") }}
              <i class="el-icon-plus"></i>
            </div>
          </div>
          <el-dialog :title="$t('main.ConsigneeInformation')" :visible.sync="addressDialogVisible" width="40%" :before-close="handleClose">
            <el-form ref="form" :model="addressData" label-width="150px">
              <el-form-item class="is-required" :label="$t('main.receiver')">
                <el-input v-model="addressData.receive_user" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item :class="isCN ? 'is-required': ''" :label="$t('main.telephone')">
                <el-input v-model="addressData.receive_phone" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item class="is-required" :label="$t('main.country')">
                <el-select
                    v-model="addressData.country"
                    clearable
                    style="width: 100%"
                    size="small"
                    :placeholder="$t('main.pleaseEnter')"
                    filterable
                    remote
                    :remote-method="remoteMethod"
                    @clear="handleEmpty"
                    :loading="loading"
                    @change="handleRemoteMethodChange($event)"
                >
                  <el-option
                      v-if="isCN"
                      v-for="(item, index) in countryList"
                      :key="index"
                      :label="item.country_name_cn"
                      :value="item.ab"
                  >
                    <span> {{ item.country_name_cn }} </span>
                    <span style="color: #8492a6"> ({{ item.country_code }} {{ item.ab }})</span>
                  </el-option>
                  <el-option
                      v-if="!isCN"
                      v-for="(item, index) in countryList"
                      :key="index"
                      :label="item.country_name_en"
                      :value="item.ab"
                  >
                    <span> {{ item.country_name_en }} </span>
                    <span style="color: #8492a6"> ({{ item.country_code }} {{ item.ab }})</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                  v-if="!isCN && (addressData.country == 'AR' || addressData.country == 'BR' || addressData.country == 'CA' || addressData.country == 'ID' || addressData.country == 'IN' || addressData.country == 'IT' || addressData.country == 'JP' || addressData.country == 'MX' || addressData.country == 'TH' || addressData.country == 'US')"
                  class="is-required"
                  :label="stateTitle"
              >
                <el-select
                    v-model="addressData.state"
                    clearable
                    style="width: 100%"
                    size="small"
                    :placeholder="$t('main.pleaseEnter')"
                    filterable
                    remote
                    :remote-method="remoteStateMethod"
                    @clear="handleStateEmpty"
                    :loading="loading"
                    @change="handleStateRemoteMethodChange($event)"
                >
                  <el-option
                      v-for="(item, index) in stateList"
                      :key="index"
                      :label="item.state_name"
                      :value="item.state_code"
                  >
                    <span> {{ item.state_name }} </span>
                    <span style="color: #8492a6"> ({{ item.state_code }})</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="is-required" :label="$t('main.city')">
                <el-input v-model="addressData.city" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item
                  :class="isCN ? '': 'is-required'"
                  :label="$t('main.postalCode')"
              >
                <el-input v-model="addressData.postal_code" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('main.orderCompany')">
                <el-input v-model="addressData.receive_company" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('main.TaxpayerIdentificationNumber')">
                <el-input
                    v-model="addressData.number"
                    :placeholder="$t('main.pleaseEnter')"
                ></el-input>
              </el-form-item>
              <el-form-item class="is-required" v-if="isCN" :label="$t('main.addressDetail')">
                <el-input v-model="addressData.receive_address" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item class="is-required" v-if="!isCN" :label="$t('main.AddressLine1')">
                <el-input v-model="addressData.receive_address" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item v-if="!isCN" :label="$t('main.AddressLine2')">
                <el-input v-model="addressData.receive_address_2" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item v-if="!isCN" :label="$t('main.AddressLine3')">
                <el-input v-model="addressData.receive_address_3" :placeholder="$t('main.pleaseEnter')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('main.setDefault')" style="width: 100%;text-align: left;">
                <el-checkbox :true-label="1"
                             :false-label="0" v-model="addressData.status" label-position="left"></el-checkbox>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button class="btn" @click="submitAddressData">{{ $t('main.sure') }}</el-button>
                <el-button class="btn-close" @click="handleClose">{{ $t('main.cancel') }}</el-button>
              </span>
          </el-dialog>

          <div class="c-th facab">
            <div>{{ $t("main.Invoice") }}</div>
            <div v-if="!isCN" class="cPointer color-635796" @click="SameAsShipping">
              {{ $t("main.SameAsShipping") }}
            </div>
          </div>

          <div v-if="isCN" class="facab c-fp c-fp-t">
            <div class="fac">
              <div
                  class="facac c-box"
                  @click="changeBillingCompanyType(1)"
                  :class="{ isChoosed: billingCompanyTypeChoose == 1 }"
              >
                {{ $t("main.Company") }}
                <img
                    v-if="billingCompanyTypeChoose == 1"
                    src="/static/product/icn_gou.png"
                    class="mImg"
                />
              </div>
              <div
                  class="facac c-box"
                  @click="changeBillingCompanyType(2)"
                  :class="{ isChoosed: billingCompanyTypeChoose == 2 }"
              >
                {{ $t("main.person") }}
                <img
                    v-if="billingCompanyTypeChoose == 2"
                    src="/static/product/icn_gou.png"
                    class="mImg"
                />
              </div>
            </div>
          </div>

          <div v-if="isCN" class="facab c-fp c-fp-t">
            <div class="fac">
              <div
                  class="facac c-box"
                  @click="changeBillingType(1)"
                  :class="{ isChoosed: billingTypeChoose == 1 }"
              >
                {{ $t("main.PlainInvoice") }}
                <img
                    v-if="billingTypeChoose == 1"
                    src="/static/product/icn_gou.png"
                    class="mImg"
                />
              </div>
              <div
                  class="facac c-box"
                  @click="changeBillingType(2)"
                  :class="{ isChoosed: billingTypeChoose == 2 }"
              >
                {{ $t("main.SpecialInvoice") }}
                <img
                    v-if="billingTypeChoose == 2"
                    src="/static/product/icn_gou.png"
                    class="mImg"
                />
              </div>
              <div
                  class="facac c-box"
                  @click="changeBillingType(3)"
                  :class="{ isChoosed: billingTypeChoose == 3 }"
              >
                {{ $t("main.PaperSpecialInvoice") }}
                <img
                    v-if="billingTypeChoose == 3"
                    src="/static/product/icn_gou.png"
                    class="mImg"
                />
              </div>
            </div>
          </div>

          <div class="addr-serach">
            <el-input
                :placeholder="$t('main.searchBilling')"
                v-model="billing_search"
                class="input-with-select"
                @keyup.enter.native="billingSearch()"
            >
              <el-button slot="append" icon="el-icon-search" @click="billingSearch()"></el-button>
            </el-input>
          </div>

          <div class="addr-list">
            <el-radio-group
                v-model="billingIdChooise"
                v-if="billingList.length"
            >
              <el-radio
                  v-for="(item, key) in billingList"
                  :key="key + 0.001"
                  :label="item.id"
              >
                <span style="font-weight: bold;color: rgb(51, 51, 51);padding-right: 1.5rem;" v-if="item.status == 1"> {{ $t('main.defaultInvoice') }}</span>
                <span v-if="billingCompanyTypeChoose == 1" style="font-weight: bold;color: rgb(51, 51, 51);"> {{ item.name }}</span>
                <span style="font-weight: bold;color: rgb(51, 51, 51);"> {{ item.receive_user }}</span>
                <span v-if="isCN" style="color: rgb(51, 51, 51);"> {{ item.receive_email }}</span>
                <span style="color: rgb(153, 153, 153);"> {{ item.address }}</span>

                <span style="color: #635796;padding-left: 1.5rem;" @click="editBillingDialog(item)"> {{ $t('main.edit') }}</span>
              </el-radio>
            </el-radio-group>
            <el-pagination
                v-if="billingList.length"
                layout="prev, pager, next"
                hide-on-single-page
                :total="billing.total"
                :current-page="billing.page"
                :page-size="billing.limit"
                @current-change="handleCurrentBillingChange"
            >
            </el-pagination>
            <div class="add-address color-635796" @click="billingDialogVisible = true;billingOperateFlag=true">
              {{ $t("main.add") }}
              <i class="el-icon-plus"></i>
            </div>
          </div>
          <el-dialog
              :visible.sync="billingDialogVisible"
              width="60%"
              :before-close="handleClose"
          >
            <div slot="title" class="dialog-title">
              {{ $t('main.Invoice') }}
            </div>
            <el-form ref="form" :model="billingData" label-width="200px">
              <template v-if="billingCompanyTypeChoose == 1">
                <el-form-item class="is-required" :label="$t('main.receiver')">
                  <el-input v-model="billingData.receive_user" :placeholder="$t('main.pleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :class="isCN ? 'is-required': ''" :label="$t('main.telephone')">
                  <el-input v-model="billingData.receive_phone" :placeholder="$t('main.pleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item v-if="isCN" class="is-required" :label="$t('main.receiveEmail')">
                  <el-input
                      v-model="billingData.receive_email"
                      :placeholder="$t('main.pleaseEnter')"
                  ></el-input>
                </el-form-item>
                <el-form-item class="is-required" :label="$t('main.country')">
                  <el-select
                      v-model="billingData.country"
                      clearable
                      style="width: 100%"
                      size="small"
                      :placeholder="$t('main.pleaseEnter')"
                      filterable
                      remote
                      :remote-method="remoteMethod"
                      @clear="handleEmpty"
                      :loading="loading"
                      @change="handleRemoteMethodChange($event)"
                  >
                    <el-option
                        v-if="isCN"
                        v-for="(item, index) in countryList"
                        :key="index"
                        :label="item.country_name_cn"
                        :value="item.ab"
                    >
                      <span> {{ item.country_name_cn }} </span>
                      <span style="color: #8492a6"> ({{ item.country_code }} {{ item.ab }})</span>
                    </el-option>
                    <el-option
                        v-if="!isCN"
                        v-for="(item, index) in countryList"
                        :key="index"
                        :label="item.country_name_en"
                        :value="item.ab"
                    >
                      <span> {{ item.country_name_en }} </span>
                      <span style="color: #8492a6"> ({{ item.country_code }} {{ item.ab }})</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="is-required" :label="$t('main.city')">
                  <el-input v-model="billingData.city" :placeholder="$t('main.pleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item
                    :class="isCN ? '': 'is-required'"
                    :label="$t('main.postalCode')"
                >
                  <el-input v-model="billingData.postal_code" :placeholder="$t('main.pleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :class="isCN ? 'is-required': ''" :label="$t('main.Company')">
                  <el-input
                      v-model="billingData.name"
                      :placeholder="$t('main.pleaseEnter')"
                  ></el-input>
                </el-form-item>
                <el-form-item :class="isCN ? 'is-required': ''" :label="$t('main.TaxpayerIdentificationNumber')">
                  <el-input
                      v-model="billingData.number"
                      :placeholder="$t('main.pleaseEnter')"
                  ></el-input>
                </el-form-item>
                <el-form-item class="is-required" v-if="isCN" :label="$t('main.CompanyAddress')">
                  <el-input
                      v-model="billingData.address"
                      :placeholder="$t('main.pleaseEnter')"
                  ></el-input>
                </el-form-item>
                <el-form-item class="is-required" v-if="!isCN" :label="$t('main.AddressLine1')">
                  <el-input v-model="billingData.address" :placeholder="$t('main.pleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item v-if="!isCN" :label="$t('main.AddressLine2')">
                  <el-input v-model="billingData.address_2" :placeholder="$t('main.pleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item v-if="!isCN" :label="$t('main.AddressLine3')">
                  <el-input v-model="billingData.address_3" :placeholder="$t('main.pleaseEnter')"></el-input>
                </el-form-item>

                <el-form-item v-if="isCN" :label="$t('main.BankName')">
                  <el-input
                      v-model="billingData.bank_name"
                      :placeholder="$t('main.pleaseEnter')"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="isCN" :label="$t('main.BankAccount')">
                  <el-input
                      v-model="billingData.bank_number"
                      :placeholder="$t('main.pleaseEnter')"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="isCN" :label="$t('main.CompanyPhone')">
                  <el-input v-model="billingData.phone" :placeholder="$t('main.pleaseEnter')"></el-input>
                </el-form-item>
              </template>
              <template v-if="billingCompanyTypeChoose == 2">
                <el-form-item class="is-required" :label="$t('main.receiver')">
                  <el-input
                      v-model="billingData.receive_user"
                      :placeholder="$t('main.pleaseEnter')"
                  ></el-input>
                </el-form-item>
                <el-form-item class="is-required" :label="$t('main.telephone')">
                  <el-input
                      v-model="billingData.receive_phone"
                      :placeholder="$t('main.pleaseEnter')"
                  ></el-input>
                </el-form-item>
                <el-form-item class="is-required" :label="$t('main.receiveEmail')">
                  <el-input
                      v-model="billingData.receive_email"
                      :placeholder="$t('main.pleaseEnter')"
                  ></el-input>
                </el-form-item>
                <el-form-item class="is-required" :label="$t('main.country')">
                  <el-select
                      v-model="billingData.country"
                      clearable
                      style="width: 100%"
                      size="small"
                      :placeholder="$t('main.pleaseEnter')"
                      filterable
                      remote
                      :remote-method="remoteMethod"
                      @clear="handleEmpty"
                      :loading="loading"
                      @change="handleRemoteMethodChange($event)"
                  >
                    <el-option
                        v-if="isCN"
                        v-for="(item, index) in countryList"
                        :key="index"
                        :label="item.country_name_cn"
                        :value="item.ab"
                    >
                      <span> {{ item.country_name_cn }} </span>
                      <span style="color: #8492a6"> ({{ item.country_code }} {{ item.ab }})</span>
                    </el-option>
                    <el-option
                        v-if="!isCN"
                        v-for="(item, index) in countryList"
                        :key="index"
                        :label="item.country_name_en"
                        :value="item.ab"
                    >
                      <span> {{ item.country_name_en }} </span>
                      <span style="color: #8492a6"> ({{ item.country_code }} {{ item.ab }})</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="is-required" :label="$t('main.city')">
                  <el-input v-model="billingData.city" :placeholder="$t('main.pleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item
                    :class="isCN ? '': 'is-required'"
                    :label="$t('main.postalCode')"
                >
                  <el-input v-model="billingData.postal_code" :placeholder="$t('main.pleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item class="is-required" :label="$t('main.Address')">
                  <el-input
                      v-model="billingData.address"
                      :placeholder="$t('main.pleaseEnter')"
                  ></el-input>
                </el-form-item>
              </template>
              <el-form-item :label="$t('main.setDefault')">
                <el-checkbox
                    :true-label="1"
                    :false-label="0"
                    v-model="billingData.status"
                    label-position="left">
                </el-checkbox>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button class="btn" @click="submitBillingData">
                {{$t('main.commit') }}
              </el-button>
              <el-button class="btn-close" @click="handleClose">
                {{ $t('main.cancel') }}
              </el-button>
            </span>
          </el-dialog>

          <div class="c-th facab">
            <div>{{ $t("main.remark") }}</div>
          </div>
          <div class="c-bz">
            <el-input
                type="textarea"
                :rows="6"
                :placeholder="$t('main.pleaseEnter')"
                v-model="note_message"
            >
            </el-input>
          </div>
          <div class="t-bottom facab">
            <div>
              <span v-if="totalNumber" style="margin-left: 2.5rem" v-html="$t('main.chooseShopNum', { num: totalNumber })"></span>
            </div>
            <div>
              <span v-if="totalPrice" style="margin-right: 2.5rem">
                {{ $t('main.totalPrice') }}：{{ $t('main.monetaryUnit') }}
                <span class="color-635796">{{ totalPrice }}</span>
              </span>
              <el-button class="mainBtm" @click="goToShipping()">
                {{ $t("main.commit") }}
              </el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="c-th">
            <div>{{ $t("main.OrderingInformation") }}</div>
          </div>
          <div class="c-table">
            <div
                class="product"
                v-for="(item, index) in shoplist"
                :key="index"
                v-if="Math.floor(index/3) <= shopListFloor"
                style="color: rgb(153, 153, 153);"
            >
              <div>
                <div style="text-align: center;">
                  <img style="cursor: pointer;" @click="gotoProductDetail(item)" :src="item.productimg" class="tr-img" />
                  <div class="td-label">
                    <div class="fac lh30" style="color: #333333;">
                      <div v-if="item.type_name" style="width: 10rem;">{{ $t('main.product') }}</div>
                      <div v-if="item.type_name" style="width: calc(100% - 10rem);cursor: pointer;color: #635796;" @click="gotoProductDetail(item)">{{item.type_name}}</div>
                    </div>
                    <div class="fac lh30" style="color: #333333;">
                      <div v-if="item.product_model" style="width: 10rem;">{{ $t('main.partNumber') }}</div>
                      <div v-if="item.product_model" style="width: calc(100% - 10rem);cursor: pointer;color: #635796;" @click="gotoProductDetail(item)">{{item.product_model}}</div>
                    </div>
                    <div class="fac lh30" style="color: #333333;">
                      <div style="width: 10rem;">{{ $t('main.totalNum') }}</div>
                      <div style="width: calc(100% - 10rem);">{{ item.number }}</div>
                    </div>
                    <div class="fac lh30" style="color: #333333;">
                      <div style="width: 10rem;">{{ $t('main.priceForOne') }}</div>
                      <div style="width: calc(100% - 10rem);">{{ item.price ? $t('main.monetaryUnit') + item.price : '/' }}</div>
                    </div>
                    <div>
                      <div class="fac" style="color: #333333;">{{ $t('main.ProductSpecifications') }}</div>
                      <div
                          class="fac lh30"
                          v-for="(itemd, index) in item.product_info"
                          v-if="itemd.isShow"
                          :key="index"
                      >
                        <div style="width: 10rem;padding-left: 1.5rem;">{{ itemd.title }}</div>
                        <div style="width: calc(100% - 10rem);">{{ itemd.value }}</div>
                      </div>
                      <div
                          class="fac lh30"
                          v-for="(itemd, index) in item.product_info"
                          v-if="!item.product_model || (!itemd.isShow && showMore.findIndex(res=>{return res == item.id;}) > -1)"
                          :key="index"
                      >
                        <div style="width: 10rem;padding-left: 1.5rem;">{{ itemd.title }}</div>
                        <div style="width: calc(100% - 10rem);">{{ itemd.value }}</div>
                      </div>
                      <div v-if="item.product_model" class="fac color-635796" style="cursor: pointer;padding-left: 1.5rem;" @click="handleProductParamsMore(item)">
                        {{ showMore.findIndex(res=>{return res == item.id;}) > -1 ? $t('main.Cut') : $t('main.More') }}
                        <i :class="showMore.findIndex(res=>{return res == item.id;}) > -1 ? 'el-icon-arrow-up':'el-icon-arrow-down'"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="t-bottom" v-if="!shopListFloorComplete">
            <div @click="handleOrderProductMore()" style="text-align: center;cursor: pointer;">
              {{ $t('main.More') }}
              <i class="el-icon-arrow-down"></i>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {addAdress, readAddress, editAddress, listAddress, addBill, editBill, getProductInfo, listBill} from "@/api/index"; //获取当前用户的地址列表
import { Shopcarlist } from "@/api/shopcar"; //获取购物车数据
import Cookies from "js-cookie";
import countryList from "@/api/country.json";
import ARStateList from "@/api/AR.json"
import BRStateList from "@/api/BR.json"
import CAStateList from "@/api/CA.json"
import IDStateList from "@/api/ID.json"
import INStateList from "@/api/IN.json"
import ITStateList from "@/api/IT.json"
import JPStateList from "@/api/JP.json"
import MXStateList from "@/api/MX.json"
import THStateList from "@/api/TH.json"
import USStateList from "@/api/US.json"

export default {
  watch: {
    "$store.state.siteInfo": function(newV, oldV) {
      this.isCN = this.$i18n.locale === "zn";
      if (newV && typeof oldV != 'object') {
        this.$router.push({ path: "/shoppingCart"});
      }
    }
  },
  created() {
    this.isCN = this.$i18n.locale === "zn";
    this.init();
    // 带搜索的下拉框
    this.remoteMethod('')
    this.remoteStateMethod('')
  },
  data() {
    return {
      isCN: true, // 判断当前是中文还是英文
      address_search: "",
      addressIdChooise: "",  // 选中的地址ID
      addressDialogVisible:false,
      addressOperateFlag:false,
      // 遮罩层
      loading: false,
      addressData: {},
      addressList: [], //
      stateList: [],
      address:{
        page: 1,
        limit: 5,
        total: 1,
      },
      stateTitle: '',
      billingCompanyTypeChoose: 1, //发票类型：1是企业 2是个人  首页
      billingTypeChoose: 1, // 开票类型：1电子普通发票 2电子专用发票 3纸质专用发票
      billing_search: "",
      billingIdChooise: "",  // 选中的地址ID
      billingDialogVisible:false,
      billingOperateFlag:false,
      billingData: {
        user_id: '',
        bill_type: 1,  // 1增值税普通发票 2 增值税专用发票
        name: '',
        number: '',
        address: '',
        phone: '',
        bank_name: '',
        bank_number: '',
        receive_user: '',
        receive_phone: '',
        receive_email: '',
        country: '',
        city: '',
        status: 0,//默认开票信息
        // type: 1,
        company_type: 1, // 1是单位 2是个人
      },
      billingList: [], //
      billing:{
        page: 1,
        limit: 5,
        total: 1,
      },
      shoplist: [], //所有购物车的信息
      shopListFloor: 0, // 订单产品数据限制每次加载3个
      shopListFloorComplete: true, // 已经加载完成
      note_message: "",
      totalPrice: window.sessionStorage.getItem("settlementInfo") ? JSON.parse(window.sessionStorage.getItem("settlementInfo")).totalPrice : 0,
      totalNumber: window.sessionStorage.getItem("settlementInfo") ? JSON.parse(window.sessionStorage.getItem("settlementInfo")).totalNumber : 0,
      showMore: [],
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },
  methods: {
    init() {
      this.initAddressList(); //查询收获地址显示
      this.initBillingList(); //查询收获地址显示
      let info = window.sessionStorage.getItem("settlementInfo");
      //查询购物车的信息根据id 显示
      if(info) {
        if(JSON.parse(info).resource) {
          let item = JSON.parse(info);
          this.shoplist.push(item);
          this.note_message = item.customForm.remark;
        } else {
          this.getCarList();
        }
      }
      this.billingTypeChoose = window.sessionStorage.getItem("billType") ? parseInt(window.sessionStorage.getItem("billType")) : 1
    },
    //获得地址列表信息
    initAddressList() {
      this.addressList = [];
      var userid = Cookies.get("userinfo") ? JSON.parse(Cookies.get("userinfo")).id : "";
      var params = {
        req: {
          page: this.address.page,
          limit: this.address.limit,
          where: [
            {
              condition: userid,
              filed: "user_id",
              expression: "="
            },
            {
              condition: Cookies.get("siteInfo"),
              filed: "site_id",
              expression: "="
            },
            {
              condition: `%${this.address_search}%`,
              filed: "receive_user|receive_phone|receive_company|receive_address|country|city|number|receive_address_2|receive_address_3",
              expression: "LIKE"
            }
          ],
          order: "id desc"
        }
      };
      listAddress(params).then((res) => {
        this.addressList = res.data.list;
        this.address.total = res.data.total;
      });
    },
    addressSearch() {
      this.initAddressList();
    },
    handleCurrentAddressChange(val) {
      this.address.page = val;
      this.initAddressList();
    },
    // 带搜索的下拉框
    remoteMethod(query) {
      const country = [];
      Object.assign(country, countryList);
      if (query) {
        this.loading = true
        this.countryList = country.filter(
            item => item.country_name_cn.toLowerCase().includes(query.toLowerCase()) ||
                item.country_name_en.toLowerCase().includes(query.toLowerCase()) ||
                item.ab.toLowerCase().includes(query.toLowerCase()) ||
                item.country_code == query
        )
        this.loading = false
      } else {
        this.countryList = country;
      }
    },
    remoteStateMethod (query) {
      if (query) {
        this.loading = true
        const state = [];
        if (this.addressData.country == 'AR') {
          this.stateTitle = "Province name";
          Object.assign(state, ARStateList);
        } else if (this.addressData.country == 'CA') {
          this.stateTitle = "Province name";
          Object.assign(state, CAStateList);
        } else if (this.addressData.country == 'ID') {
          this.stateTitle = "Province name";
          Object.assign(state, IDStateList);
        } else if (this.addressData.country == 'IT') {
          this.stateTitle = "Province name";
          Object.assign(state, ITStateList);
        } else if (this.addressData.country == 'TH') {
          this.stateTitle = "Province name";
          Object.assign(state, THStateList);
        } else if (this.addressData.country == 'BR') {
          this.stateTitle = "State name";
          Object.assign(state, BRStateList);
        } else if (this.addressData.country == 'IN') {
          this.stateTitle = "State name";
          Object.assign(state, INStateList);
        } else if (this.addressData.country == 'MX') {
          this.stateTitle = "State name";
          Object.assign(state, MXStateList);
        } else if (this.addressData.country == 'US') {
          this.stateTitle = "State name";
          Object.assign(state, USStateList);
        } else if (this.addressData.country == 'JP') {
          this.stateTitle = "Prefecture name";
          Object.assign(state, JPStateList);
        }
        this.stateList = state.filter(
            item => item.state_name.toLowerCase().includes(query.toLowerCase()) ||
                item.state_code.toLowerCase().includes(query.toLowerCase())
        )
        this.loading = false
      } else {
        const state = [];
        if (this.addressData.country == 'AR') {
          this.stateTitle = "Province name";
          Object.assign(state, ARStateList);
          this.stateList = state;
        } else if (this.addressData.country == 'CA') {
          this.stateTitle = "Province name";
          Object.assign(state, CAStateList);
          this.stateList = state;
        } else if (this.addressData.country == 'ID') {
          this.stateTitle = "Province name";
          Object.assign(state, IDStateList);
          this.stateList = state;
        } else if (this.addressData.country == 'IT') {
          this.stateTitle = "Province name";
          Object.assign(state, ITStateList);
          this.stateList = state;
        } else if (this.addressData.country == 'TH') {
          this.stateTitle = "Province name";
          Object.assign(state, THStateList);
          this.stateList = state;
        } else if (this.addressData.country == 'BR') {
          this.stateTitle = "State name";
          Object.assign(state, BRStateList);
          this.stateList = state;
        } else if (this.addressData.country == 'IN') {
          this.stateTitle = "State name";
          Object.assign(state, INStateList);
          this.stateList = state;
        } else if (this.addressData.country == 'MX') {
          this.stateTitle = "State name";
          Object.assign(state, MXStateList);
          this.stateList = state;
        } else if (this.addressData.country == 'US') {
          this.stateTitle = "State name";
          Object.assign(state, USStateList);
          this.stateList = state;
        } else if (this.addressData.country == 'JP') {
          this.stateTitle = "Prefecture name";
          Object.assign(state, JPStateList);
          this.stateList = state;
        }
      }
    },
    handleStateEmpty() {
      const state = [];
      if (this.addressData.country == 'AR') {
        this.stateTitle = "Province name";
        Object.assign(state, ARStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'CA') {
        this.stateTitle = "Province name";
        Object.assign(state, CAStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'ID') {
        this.stateTitle = "Province name";
        Object.assign(state, IDStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'IT') {
        this.stateTitle = "Province name";
        Object.assign(state, ITStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'TH') {
        this.stateTitle = "Province name";
        Object.assign(state, THStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'BR') {
        this.stateTitle = "State name";
        Object.assign(state, BRStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'IN') {
        this.stateTitle = "State name";
        Object.assign(state, INStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'MX') {
        this.stateTitle = "State name";
        Object.assign(state, MXStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'US') {
        this.stateTitle = "State name";
        Object.assign(state, USStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'JP') {
        this.stateTitle = "Prefecture name";
        Object.assign(state, JPStateList);
        this.stateList = state;
      }
    },
    handleStateRemoteMethodChange(e) {
      const state = [];
      if (this.addressData.country == 'AR') {
        this.stateTitle = "Province name";
        Object.assign(state, ARStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'CA') {
        this.stateTitle = "Province name";
        Object.assign(state, CAStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'ID') {
        this.stateTitle = "Province name";
        Object.assign(state, IDStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'IT') {
        this.stateTitle = "Province name";
        Object.assign(state, ITStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'TH') {
        this.stateTitle = "Province name";
        Object.assign(state, THStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'BR') {
        this.stateTitle = "State name";
        Object.assign(state, BRStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'IN') {
        this.stateTitle = "State name";
        Object.assign(state, INStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'MX') {
        this.stateTitle = "State name";
        Object.assign(state, MXStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'US') {
        this.stateTitle = "State name";
        Object.assign(state, USStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'JP') {
        this.stateTitle = "Prefecture name";
        Object.assign(state, JPStateList);
        this.stateList = state;
      }
    },
    handleEmpty() {
      const country = [];
      Object.assign(country, countryList);
      this.countryList = country;
    },
    editAddressDialog(item) {
      this.addressDialogVisible = true;
      this.addressOperateFlag = false;
      this.addressData = item;

      const state = [];
      if (this.addressData.country == 'AR') {
        this.stateTitle = "Province name";
        Object.assign(state, ARStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'CA') {
        this.stateTitle = "Province name";
        Object.assign(state, CAStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'ID') {
        this.stateTitle = "Province name";
        Object.assign(state, IDStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'IT') {
        this.stateTitle = "Province name";
        Object.assign(state, ITStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'TH') {
        this.stateTitle = "Province name";
        Object.assign(state, THStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'BR') {
        this.stateTitle = "State name";
        Object.assign(state, BRStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'IN') {
        this.stateTitle = "State name";
        Object.assign(state, INStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'MX') {
        this.stateTitle = "State name";
        Object.assign(state, MXStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'US') {
        this.stateTitle = "State name";
        Object.assign(state, USStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'JP') {
        this.stateTitle = "Prefecture name";
        Object.assign(state, JPStateList);
        this.stateList = state;
      }
    },
    //添加和修改
    submitAddressData() {
      // TODO 组装数据
      if (this.addressOperateFlag == false) {
        var params = {
          "req": {
            "id": this.addressData.id,
            "info": this.addressData
          }
        }
        if (this.isCN && !this.addressData.receive_phone) {
          // 中文 电话 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.telephone') }),
            type: 'error'
          })
          return
        }
        if (!this.isCN && !this.addressData.postal_code) {
          // 英文 邮编 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.postalCode') }),
            type: 'error'
          })
          return
        }
        if (!this.isCN &&
            (this.addressData.country == 'AR' || this.addressData.country == 'BR' || this.addressData.country == 'CA' || this.addressData.country == 'ID' || this.addressData.country == 'IN' || this.addressData.country == 'IT' || this.addressData.country == 'JP' || this.addressData.country == 'MX' || this.addressData.country == 'TH' || this.addressData.country == 'US') &&
            !this.addressData.state
        ) {
          // 英文 邮编 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.stateTitle }),
            type: 'error'
          })
          return
        }
        editAddress(params).then((res) => {
          if(res.rsp.code === 0) {
            this.addressIdChooise = parseInt(res.data.id);
            this.initAddressList();
            this.handleClose();
            this.$message({
              message: this.$t('main.operationCompletedSuccessfully'),
              type: 'success',
            })
          }else{
            this.$message({
              message: res.rsp.msg,
              type: 'error'
            })
          }
        });
      } else {
        var params2 = {
          "req": {
            "user_id": JSON.parse(Cookies.get('userinfo')).id,
            "receive_user": this.addressData.receive_user,
            "receive_email": this.addressData.receive_email,
            "receive_phone": this.addressData.receive_phone,
            "receive_company": this.addressData.receive_company,
            "country": this.addressData.country,
            "state": this.addressData.state,
            "city": this.addressData.city,
            "postal_code": this.addressData.postal_code,
            "number": this.addressData.number,
            "receive_address": this.addressData.receive_address,
            "receive_address_2": this.addressData.receive_address_2,
            "receive_address_3": this.addressData.receive_address_3,
            "status": 0
          }
        }
        if (this.isCN && !this.addressData.receive_phone) {
          // 中文 电话 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.telephone') }),
            type: 'error'
          })
          return
        }
        if (!this.isCN && !this.addressData.postal_code) {
          // 英文 邮编 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.postalCode') }),
            type: 'error'
          })
          return
        }
        if (!this.isCN &&
            (this.addressData.country == 'AR' || this.addressData.country == 'BR' || this.addressData.country == 'CA' || this.addressData.country == 'ID' || this.addressData.country == 'IN' || this.addressData.country == 'IT' || this.addressData.country == 'JP' || this.addressData.country == 'MX' || this.addressData.country == 'TH' || this.addressData.country == 'US') &&
            !this.addressData.state
        ) {
          // 英文 邮编 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.stateTitle }),
            type: 'error'
          })
          return
        }
        addAdress(params2).then((res) => {
          if(res.rsp.code === 0) {
            this.$message({
              message: this.$t('main.operationCompletedSuccessfully'),
              type: 'success',
            })
            this.addressIdChooise = parseInt(res.data.id);
            this.initAddressList();
            this.handleClose();
          } else {
            this.$message({
              message: res.rsp.msg,
              type: 'error'
            })
          }
        });
      }
    },
    //获得发票列表信息
    initBillingList() {
      this.billingList = [];
      var userid = Cookies.get("userinfo") ? JSON.parse(Cookies.get("userinfo")).id : "";
      var params = {
        req: {
          page: this.billing.page,
          limit: this.billing.limit,
          where: [
            {
              condition: userid,
              filed: "user_id",
              expression: "="
            },
            {
              condition: Cookies.get("siteInfo"),
              filed: "site_id",
              expression: "="
            },
            {
              condition: this.billingCompanyTypeChoose.toString(),
              filed: "company_type",
              expression: "="
            },
            {
              condition: `%${this.billing_search}%`,
              filed: "receive_user|receive_phone|receive_email|name|number|address|country|city|number|address_2|address_3|bank_name|bank_number|phone",
              expression: "LIKE"
            }
          ],
          order: "id desc"
        }
      };
      listBill(params).then((res) => {
        this.billingList = res.data.list;
        this.billing.total = res.data.total;
      });
    },
    billingSearch() {
      this.initBillingList();
    },
    handleCurrentBillingChange(val) {
      this.billing.page = val;
      this.initBillingList();
    },
    handleRemoteMethodChange (e) {
      this.addressData.country = e;
      this.billingData.country = e;
      const country = [];
      Object.assign(country, countryList);
      this.countryList = country;

      const state = [];
      if (this.addressData.country == 'AR') {
        this.stateTitle = "Province name";
        Object.assign(state, ARStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'CA') {
        this.stateTitle = "Province name";
        Object.assign(state, CAStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'ID') {
        this.stateTitle = "Province name";
        Object.assign(state, IDStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'IT') {
        this.stateTitle = "Province name";
        Object.assign(state, ITStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'TH') {
        this.stateTitle = "Province name";
        Object.assign(state, THStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'BR') {
        this.stateTitle = "State name";
        Object.assign(state, BRStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'IN') {
        this.stateTitle = "State name";
        Object.assign(state, INStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'MX') {
        this.stateTitle = "State name";
        Object.assign(state, MXStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'US') {
        this.stateTitle = "State name";
        Object.assign(state, USStateList);
        this.stateList = state;
      } else if (this.addressData.country == 'JP') {
        this.stateTitle = "Prefecture name";
        Object.assign(state, JPStateList);
        this.stateList = state;
      }
    },
    handleClose() {
      this.addressDialogVisible = false;
      this.billingDialogVisible = false;
      this.resetForm();
    },
    // 清空表单
    resetForm(){
      this.addressData = {
        receive_user: "",
        receive_email: "",
        receive_phone: "",
        receive_company: "",
        country: "",
        city: "",
        postal_code: "",
        number: "",
        receive_address: "",
        receive_address_2: "",
        receive_address_3: "",
        status: 0,//默认开票信息
      }
      this.billingData = {
        user_id: '',
        name: '',
        number: '',
        address: '',
        phone: '',
        bank_name: '',
        bank_number: '',
        receive_user: '',
        receive_phone: '',
        receive_email: '',
        status: '',
        company_type: "1",
      }
    },
    editBillingDialog(item) {
      this.billingDialogVisible = true;
      this.billingOperateFlag = false;
      this.billingData = item;
    },
    //添加和修改
    submitBillingData() {
      if (!this.isCN) {
        this.billingData.company_type = 1;
      }
      // TODO 组装数据
      if (this.billingOperateFlag == false) {
        // 编辑发票时

        var params = {
          "req": {
            "id": this.billingData.id,
            "info": this.billingData
          }
        }
        if (!this.isCN && !this.billingData.postal_code) {
          // 英文 邮编 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.postalCode') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && !this.billingData.receive_phone) {
          // 中文 电话 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.telephone') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && this.billingData.company_type == 1 && !this.billingData.name) {
          // 中文 企业发票 公司名必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.Company') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && this.billingData.company_type == 1 && !this.billingData.number) {
          // 中文 企业发票 纳税人识别号必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.TaxpayerIdentificationNumber') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && !this.billingData.receive_email) {
          // 中文 企业发票 接受发票邮箱必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.receiveEmail') }),
            type: 'error'
          })
          return
        }
        editBill(params).then((res) => {
          if(res.rsp.code === 0) {
            this.billingIdChooise = parseInt(res.data.id);
            this.initBillingList();
            this.handleClose();
            this.$message({
              message: this.$t('main.operationCompletedSuccessfully'),
              type: 'success',
            })
          }else{
            this.$message({
              message: res.rsp.msg,
              type: 'error'
            })
          }
        });
      } else {
        // 添加发票时
        this.billingData.user_id =
            Cookies.get('userinfo') && JSON.parse(Cookies.get('userinfo')).id
        let params2 = this.billingData
        if (!this.isCN && !this.billingData.postal_code) {
          // 英文 邮编 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.postalCode') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && !this.billingData.receive_phone) {
          // 中文 电话 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.telephone') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && this.billingData.company_type == 1 && !this.billingData.name) {
          // 中文 企业发票 公司名必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.Company') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && this.billingData.company_type == 1 && !this.billingData.number) {
          // 中文 企业发票 纳税人识别号必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.TaxpayerIdentificationNumber') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && !this.billingData.receive_email) {
          // 中文 企业发票 接受发票邮箱必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.receiveEmail') }),
            type: 'error'
          })
          return
        }
        addBill({ 'req': params2 }).then((res) => {
          if(res.rsp.code === 0) {
            this.$message({
              message: this.$t('main.operationCompletedSuccessfully'),
              type: 'success',
            })
            this.billingIdChooise = parseInt(res.data.id);
            this.initBillingList();
            this.handleClose();
          } else {
            this.$message({
              message: res.rsp.msg,
              type: 'error'
            })
          }
        });
      }
    },
    // 改变发票类型 1企业 2个人
    changeBillingCompanyType(val) {
      this.billingCompanyTypeChoose = val;
      this.billingData.company_type = this.billingCompanyTypeChoose.toString();
      this.initBillingList();
    },
    //发票相应的方法
    changeBillingType(val) {
      this.billingTypeChoose = val;
      window.sessionStorage.setItem("billType", val);
    },
    //获取当前有用户所有购物车的信息
    getCarList() {
      var params = {
        req: {
          page: 1,
          limit: 1000,
          where: [
            {
              "condition": Cookies.get("siteInfo"),
              "filed": "site_id",
              "expression": "="
            }
          ]
        }
      };
      Shopcarlist(params).then((res) => {
        const productType = this.treeToArray(JSON.parse(localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))));
        for (var i = 0; i < res.data.list.length; i++) {
          for (var j = 0; j < JSON.parse(window.sessionStorage.getItem('settlementInfo')).product_id_numbers.length; j++) {
            if (
              res.data.list[i].product_id ==
              JSON.parse(window.sessionStorage.getItem("settlementInfo")).product_id_numbers[j].product_id
            ) {
              const nowProductType = productType.find(productType => {
                return productType.id == res.data.list[i].product_info.type_id;
              });
              const singleData = {
                uuid: res.data.list[i].uuid,
                user_id: res.data.list[i].user_id,
                type_id: res.data.list[i].product_info.type_id,
                type_name: nowProductType.name,
                product_id: res.data.list[i].product_id,
                product_model: res.data.list[i].product_info.product_model,
                product_info: res.data.list[i].product_info.product_data,
                price: res.data.list[i].price,
                number: res.data.list[i].number,
                site_id: "",
                productimg: res.data.list[i].product_info.thumb,
                kucun: res.data.list[i].product_info.stock,
                id: Date.now().toString(36) + i,
                checked: false // 购物车是否选中
                //缺少字段：1，产品图片
              };
              this.shoplist.push(singleData);
            }
          }
        }

        this.shopListFloorComplete = this.shoplist.length <= 3;
      });
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      if (data) {
        auxiliary(data);
      }
      return res;
    },
    SameAsShipping() {
      if (!this.addressIdChooise) {
          this.$message({
            message: this.$t('main.pleaseSelectAddress'),
            type: 'error'
          })
      } else {
        let params = {
          req: {
            id: this.addressIdChooise
          }
        };
        readAddress(params).then((res) => {
          //console.log(res);
          if (res.rsp.code === 0) {
            this.billingData = {
              user_id: res.data.user_id,
              name: res.data.receive_company,
              number: res.data.number,
              address: res.data.receive_address,
              receive_phone: res.data.receive_phone,
              receive_user: res.data.receive_user,
              country: res.data.country,
              city: res.data.city,
              postal_code: res.data.postal_code,
              address_2: res.data.receive_address_2,
              address_3: res.data.receive_address_3,
              company_type: "1",
              status: "0"
            }
            this.billingDialogVisible = true;
            this.billingOperateFlag   = true
          } else {
            this.$message({
              message: res.rsp.msg,
              type: 'error'
            })
          }
        })
      }
    },
    // 组装数据提交订单请求
    goToShipping() {
      if (!this.addressIdChooise) {
        this.$message({
          message: this.$t('main.pleaseSelectAddress'),
          type: 'error'
        })
        return
      } else if (!this.billingIdChooise) {
        this.$message({
          message: this.$t('main.pleaseSelectBilling'),
          type: 'error'
        })
        return
      } else if (!this.billingTypeChoose) {
        this.$message({
          message: this.$t('main.pleaseSelectBillingType'),
          type: 'error'
        })
        return
      }

      //组装要传到支付页面的数据
      let cookie = window.sessionStorage.getItem("settlementInfo");
      cookie = cookie && JSON.parse(cookie);
      window.sessionStorage.setItem("settlementInfo", JSON.stringify({
        ...cookie,
        address_id: this.addressIdChooise,
        billing_id: this.billingIdChooise,
        bill_type: this.billingTypeChoose,
        note_message: this.note_message
      }))

      this.$router.push({ path: "/shippingMethod"});
    },
    //到产品界面
    gotoProductDetail(item) {
      let params = {
        req: {
          id: item.type_id
        }
      };
      getProductInfo(params).then(res => {
        if(res.rsp.code === 0) {
          const toItem = res.data;
          let route = this.$router.resolve({
            path: this.getRoutesPath('detail_product', toItem['identification'], toItem['id']),
            query: {
              keyword: item.product_model,
              anchor: "filter"
            }
          });
          window.open(route.href, "_blank");
          window.sessionStorage.setItem("recommend", true);
        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
        }
      });
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    handleProductParamsMore(item) {
      let isExit = this.showMore.findIndex(res=>{
        return res == item.id;
      });
      if (isExit > -1) {
        this.showMore.splice(isExit, 1);
      } else {
        this.showMore.push(item.id);
      }
    },
    handleOrderProductMore() {
      this.shopListFloor = this.shopListFloor + 1;
      if (Math.floor((this.shoplist.length-1)/3) === this.shopListFloor) {
        this.shopListFloorComplete = true;
      }
    }
  },
  beforeDestroy() {
    // window.sessionStorage.removeItem("settlementInfo");
  }
};
</script>

<style scoped lang="less">
.pages {
  min-height: 100%;
  background-color: #fff;

  .top {
    .t-l {
      font-size: 1.875rem;
      font-family: YouSheBiaoTiHei,serif;
      font-weight: 400;
      color: #635796;
      line-height: 2.25rem;
    }

    .t-r {
      border-bottom: 2px solid #635796;
      height: 2.125rem;
      line-height: 2rem;

      .t-r-l {
        background: #635796;
        border-radius: 2px;
      }

      .t-r-e {
        padding: 0 1.25rem;
      }

      .tImg {
        width: 1.5rem;
        height: 0.75rem;
        margin: 0 0.75rem;
      }
    }
  }

  .content {
    .c-th {
      height: 3.75rem;
      line-height: 3.75rem;
      background: #f2f2f2;
      border: 1px solid #e6e6e6;
      padding: 0 0.625rem;
    }

    .addr-serach {
      padding: 1.5rem 4.5rem;
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;
    }

    .addr-list {
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;

      .el-radio-group {
        width: 100%;

        .el-radio {
          word-wrap: break-word;
          word-break: normal;
          white-space: normal;
        }
      }
    }

    .el-radio {
      display: block;
      padding: 0.5rem 4.5rem;
    }

    .el-pagination {
      padding: 1.5rem 4.5rem;
      text-align: center;
    }

    .c-addr {
      padding: 2rem 0.625rem;
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;
    }

    .c-table {
      border: 1px solid #f5f5f5;
      .lh30{
        line-height: 1.5rem;
      }
      .td-label {
        text-align: left;
      }


      .product:nth-child(even) {
        background: #f5f5f5;
      }
      .product {
        margin: 0.5rem 0;
        padding: 0.5rem 1rem;
        // border: 1px solid #f5f5f5;
        background: #fafafa;
      }

      .tr-img {
        height: 4.8rem;
        margin-right: 1.5rem;
      }
    }

    .c-fp {
      padding: 2rem 4.5rem 0;
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;
    }

    .c-box {
      padding: 0 1.5rem;
      line-height: 1.75rem;
      border: 1px solid #e6e6e6;
      border-radius: 2px;
      text-align: center;
      cursor: pointer;
      font-size: 12px;
      color: #4d4d4d;
    }

    .c-fp-b {
      margin-top: 2rem;
      padding: 0 1.5rem;
      line-height: 2.75rem;
      background: #fafafa;
    }

    .c-ps {
      padding: 2rem 0.75rem 3rem;
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;
    }

    .c-bz {
      padding: 1rem 30% 1.5rem 1.25rem;
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;
    }

    .c-box + .c-box {
      margin-left: 3.75rem;
    }

    .t-bottom {
      height: 3.75rem;
      line-height: 3.75rem;
      border: 1px solid #e6e6e6;
      background: #f2f2f2;

      .mainBtm {
        width: 10rem;
        height: 3.75rem;
        background: #635796;
        color: #ffffff;
      }
    }
  }

  @media screen and (max-width: 1400px) {
    .top {
      padding: 3.25rem 2%;
    }
    .content {
      padding: 0 2% 3.25rem;
    }
  }
  @media screen and (min-width: 1400px) {
    .top {
      padding: 3.25rem 10%;
    }
    .content {
      padding: 0 10% 3.25rem;
    }
  }
  @media screen and (min-width: 1700px) {
    .top {
      padding: 3.25rem 15%;
    }
    .content {
      padding: 0 15% 3.25rem;
    }
  }

  .mImg {
    width: 0.75rem;
    height: 0.625rem;
  }
}

.bill-info {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  div {
    min-width: 25%;
  }
}

.add-address {
  height: 80px;
  line-height: 80px;
  text-align: center;

  &:hover {
    cursor: pointer;
  }
}

.facab {
  flex-wrap: wrap;
}

/deep/ .el-dialog__header {
  background: #f2f2f2;
  padding: 1rem 1rem 1rem 1.5rem;
  border-radius: 2px;
}

/deep/ .el-input__suffix {
  height: 32px;
}

/deep/ .el-input__suffix .el-input__icon{
  color: #c0c4cc;
  line-height: 32px;
}

.btn {
  background: #635796;
  border-radius: 4px;
  border-color: #635796;
  color: #ffffff;
}
.btn-close {
  background: #FFF;
  border-radius: 4px;
  border-color: #DCDFE6;
  color: #606266;
}
</style>
